import { Component } from '@theme/component';
import { getWishlistItems, FcWishlistChangeEvent } from '@theme/fc-wishlist-api';

/**
 * Header wishlist icon with a count bubble, mirrors cart-icon's bubble
 * shape. Count is empty/hidden when the wishlist is empty.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} count
 * @extends {Component<Refs>}
 */
class FcWishlistHeaderIcon extends Component {
  requiredRefs = ['count'];

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(FcWishlistChangeEvent.eventName, this.#onChange);
    this.#sync();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(FcWishlistChangeEvent.eventName, this.#onChange);
  }

  async #sync() {
    const items = await getWishlistItems();
    this.#render(items.length);
  }

  /** @param {Event} event */
  #onChange = (event) => {
    this.#render(/** @type {CustomEvent} */ (event).detail.length);
  };

  /** @param {number} count */
  #render(count) {
    this.classList.toggle('fc-wishlist-header-icon--has-items', count > 0);
    this.refs.count.textContent = count > 0 ? String(count) : '';
  }
}

if (!customElements.get('fc-wishlist-header-icon')) {
  customElements.define('fc-wishlist-header-icon', FcWishlistHeaderIcon);
}
